import { createElement, memo, useEffect } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useIntentionData } from './hooks/useIntentionData';
import View from '@hfe/max-view';
/**
 * 意向度流量路由组件
 *
 * 职责：
 * 1. 请求用户意向度接口，获取各业务线意向度分数
 * 2. 找出最高意向度业务线，通过 TabFollowEvent 联动 Tab 组件切换到对应 index
 *
 * 本组件不渲染任何 UI，仅作为逻辑驱动层。
 */
const IntentedTrafficRouter = (props) => {
    const { tabBusinessLines = [] } = props;
    const ctx = useMonitorEngineContext();
    const { queryIntentionInfo, maxIntentionBiz } = useIntentionData();
    useEffect(() => {
        const run = async () => {
            await queryIntentionInfo().catch(() => { });
            if (maxIntentionBiz.current) {
                const index = tabBusinessLines.findIndex(line => line.bizType === maxIntentionBiz.current);
                if (index !== -1) {
                    console.log("TabFollowEvent emit ", index);
                    ctx._communication?.emit('TabFollowEvent', {
                        index
                    });
                }
            }
        };
        run();
    }, []);
    return <View></View>;
};
export default memo(IntentedTrafficRouter);
